import { api } from './api';

const leadService = {
  // Get all leads with pagination and filters
  getLeads: async (params = {}) => {
    const response = await api.get('/leads', { params });
    return response; // Return the full response to get meta and data
  },

  // Get single lead by ID
  getLeadById: async (id) => {
    const response = await api.get(`/leads/${id}`);
    return response;
  },

  // Create new lead
  createLead: async (leadData) => {
    const response = await api.post('/leads', leadData);
    return response;
  },

  // Update lead
  updateLead: async (id, leadData) => {
    const response = await api.put(`/leads/${id}`, leadData);
    return response;
  },

  // Delete lead
  deleteLead: async (id) => {
    const response = await api.delete(`/leads/${id}`);
    return response;
  },

  // Get leads assigned to current user
  getMyLeads: async (params = {}) => {
    const response = await api.get('/leads/my-leads', { params });
    return response;
  },

  // Get lead statistics
  getLeadStatistics: async (params = {}) => {
    const response = await api.get('/leads/statistics', { params });
    return response;
  },

  // Add comment to lead
  addComment: async (leadId, commentData) => {
    const response = await api.post(`/leads/${leadId}/comments`, commentData);
    return response;
  },

  // Convert lead to client
  convertToClient: async (leadId, clientData) => {
    const response = await api.post(`/leads/${leadId}/convert`, clientData);
    return response;
  },

  // Search leads
  searchLeads: async (searchTerm) => {
    const response = await api.get('/leads', {
      params: { search: searchTerm }
    });
    return response;
  }
};

export default leadService;